import { render } from "./AddComment.vue?vue&type=template&id=7e766974&scoped=true"
import script from "./AddComment.vue?vue&type=script&lang=js"
export * from "./AddComment.vue?vue&type=script&lang=js"

import "./AddComment.vue?vue&type=style&index=0&id=7e766974&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7e766974"]])

export default __exports__